import DashboardLayout from '@/pages/layout/DashboardLayout.vue'
import SpacedContent from '@/pages/layout/SpacedContent.vue'
import SecondLevelLayout from '@/pages/layout/SecondLevelLayout.vue'

import Logout from '@/pages/Logout.vue'
import Login from '@/pages/Login.vue'

import Users from '@/pages/users/usersAndGroups/main'
import Accounts from '@/pages/users/accounts/main.vue'
import AccountsGroups from '@/pages/users/accountsGroups/main.vue'
import CardPools from '@/pages/users/cardPools/main.vue'
import Groups from '@/pages/users/groups/main.vue'
import SystemGroups from '@/pages/users/systemGroups/main.vue'
import SystemUsers from '@/pages/users/systemUsers/main.vue'
import TelephoneNum from '@/pages/users/telephoneNum/main.vue'
import DeletedUsers from '@/pages/users/deletedUsers/main.vue'
import Dashboard from '@/pages/users/dashboard/Dashboard.vue'
import Support from '@/pages/users/support/support.vue'

import TarifficationTariffs from '@/pages/tariffication/servicesAndTariffs/tariffPlans/main.vue'
import TarifficationServices from '@/pages/tariffication/servicesAndTariffs/services/main.vue'
import TarifficationServicesTemplates from '@/pages/tariffication/servicesAndTariffs/servicesTemplates/main.vue'
import TarifficationServicesInTariffs from '@/pages/tariffication/servicesAndTariffs/servicesInTariffs/main.vue'
import TarifficationAccountingPeriods from '@/pages/tariffication/additional/accountingPeriods/main.vue'
import TarifficationChargePolicies from '@/pages/tariffication/additional/chargePolicies/main.vue'
import TarifficationCoefficientScheme from '@/pages/tariffication/additional/coefficientScheme/main.vue'
import TarifficationContractType from '@/pages/tariffication/other/contractType/main.vue'
import TarifficationTimeRanges from '@/pages/tariffication/other/timeRanges/main.vue'

import Banks from '@/pages/referenceBook/banks/main.vue'
import Buildings from '@/pages/referenceBook/buildings/main.vue'
import Currency from '@/pages/referenceBook/currency/main.vue'
import IPzone from '@/pages/referenceBook/IPzone/main.vue'
import Streets from '@/pages/referenceBook/streets/main.vue'
import PaymentsMethods from '@/pages/referenceBook/paymentsMethods/main.vue'
import Companies from '@/pages/referenceBook/companies/main.vue'

import ReportsOther from '@/pages/reports/other/main.vue'
import ReportsOtherBlocking from '@/pages/reports/other/blocking/main.vue'
import ReportsOtherChangeLog from '@/pages/reports/other/changeLog/main.vue'
import ReportsOtherDHCPLease from '@/pages/reports/other/dhcpLease/main.vue'
import ReportsOtherSessions from '@/pages/reports/other/sessions/main.vue'
import ReportsPayments from '@/pages/reports/payments/main.vue'
import ReportsPaymentsPayments from '@/pages/reports/payments/payments/main.vue'
import ReportsPaymentOrders from '@/pages/reports/payments/paymentOrders/main.vue'
import ReportsPaymentsInternalTransfer from '@/pages/reports/payments/internalTransfer/main.vue'
import ReportsPaymentsExpiringPayments from '@/pages/reports/payments/expiringPayments/main.vue'
import ReportsPaymentsOtherCharges from '@/pages/reports/payments/otherCharges/main.vue'
import ReportsPaymentsDocuments from '@/pages/reports/payments/documents/main.vue'
import ReportsServices from '@/pages/reports/services/main.vue'
import ReportsServicesGeneral from '@/pages/reports/services/general/main.vue'
import ReportsServicesServices from '@/pages/reports/services/services/main.vue'
import ReportsServicesCustomChargesReport from '@/pages/reports/services/customChargesReport/main.vue'
import ReportsServicesTraffic from '@/pages/reports/services/traffic/main.vue'
import ReportsServicesDetailedTraffic from '@/pages/reports/services/detailedTraffic/main.vue'
import ReportsServicesTelephony from '@/pages/reports/services/telephony/main.vue'
import ReportsServicesTelephonyDirectionsReport from '@/pages/reports/services/telephonyDirectionsReport/main.vue'

import InventoryProfiles from '@/pages/inventory/inventoryProfiles/main.vue'
import InventorySwitches from '@/pages/inventory/switches/main.vue'
import NetFlowproviders from '@/pages/inventory/netFlowProviders/main.vue'
import Firewalls from '@/pages/inventory/firewalls/main.vue'
import FirewallRules from '@/pages/inventory/firewallRules/main.vue'
import NASlist from '@/pages/inventory/NASlist/main.vue'
import TrafficCollectors from '@/pages/inventory/trafficCollectors/main.vue'
import RabbitMQ from '@/pages/inventory/rabbitMQ/main.vue'
import HTTPServers from '@/pages/inventory/httpServers/main.vue'

import DocumentTemplates from '@/pages/settings/documents/documentTemplates/main.vue'
import ProfilesOfDocuments from '@/pages/settings/documents/profilesOfDocuments/main.vue'
import ReplacementsInDocument from '@/pages/settings/documents/replacementsInDocument/main.vue'
import ArchiveDB from '@/pages/settings/system/archiveDB/main.vue'
import SettingsSystem from '@/pages/settings/system/settingsSystem/main.vue'
import Additional from '@/pages/settings/system/additional/main'
import radiusAccounts from '@/pages/settings/system/radiusAccounts/main.vue'
import DynamicShaping from '@/pages/settings/system/dynamicShaping/main.vue'

import EmergencyCalls from '@/pages/telephony/emergencyCalls/main.vue'
import TelephoneOperators from '@/pages/telephony/telephoneOperators/main.vue'
import TelephoneTarifficationDirections from '@/pages/telephony/telephoneDirections/main.vue'
import TelephoneTarifficationZones from '@/pages/telephony/telephoneZones/main.vue'

import CustomerPaymentSystems from '@/pages/customerPortal/paymentSystems/main.vue'
import CustomerSwitchTariff from '@/pages/customerPortal/switchTariff/main.vue'
import CustomerPromisedPayments from '@/pages/customerPortal/promisedPayments/main.vue'
import CustomerTransferFunds from '@/pages/customerPortal/transferFunds/main.vue'
import CustomerVoluntarySuspension from '@/pages/customerPortal/voluntarySuspension/main.vue'
import CustomerIndependentServiceConnect from '@/pages/customerPortal/customerIndependentServiceConnect/main.vue'
import CustomerCaptivePortal from '@/pages/customerPortal/captivePortal/main.vue'
import CustomerCustomerRentsoft from '@/pages/customerPortal/rentsoft/main.vue'
import CustomerCustomerTSChat from '@/pages/customerPortal/chat/main.vue'
import CustomerEditProfile from '@/pages/customerPortal/editProfile/main.vue'
import CustomerAvailReports from '@/pages/customerPortal/reports/main.vue'
import CustomerAvailDocs from '@/pages/customerPortal/docs/main.vue'
import CustomerAvailContracts from '@/pages/customerPortal/contracts/main.vue'
import CustomerActivatingCard from '@/pages/customerPortal/activatingChat/main.vue'
import Customer24TV from '@/pages/customerPortal/24tv/main.vue'
import CustomerSSRService from '@/pages/customerPortal/sirService/main.vue'

import NetworkTrafficClasses from '@/pages/network/trafficClasses/main.vue'
import NetworkISGattributes from '@/pages/network/ISGattributes/main.vue'
import NetworkTunnelRadiusAttributes from '@/pages/network/TunnelRadiusAttributes/main.vue'

import NetworkISGprofile from '@/pages/network/ISGprofile/main.vue'
import NetworkIPGroups from '@/pages/network/ipgroups/main.vue'
import NetworkDhcpPools from '@/pages/network/dhcpPools/main.vue'
import NetworkDhcpLeases from '@/pages/network/dhcpLease/main.vue'
import NetworkDHCPv6Tab from '@/pages/network/DHCPv6/main.vue'
import mainDHCPv6 from '@/pages/network/DHCPv6/mainDHCPv6/main.vue'
import ClientClassification from '@/pages/network/DHCPv6/clientClassification/main.vue'
import Subnets from '@/pages/network/DHCPv6/subnets/main.vue'
import SharedNetworks from '@/pages/network/DHCPv6/sharedNetworks/main.vue'
import OptionDef from '@/pages/network/DHCPv6/optionDef/main.vue'
import NetworkIPpools from '@/pages/network/ipPools/main.vue'

const ifAuthenticated = (to, from, next) => {
  if (document.cookie.indexOf('session_id') > -1) {
    if (to.name === 'Login') {
      next('users')
      return
    }
    next()
    return
  }
  if (to.name === 'Login') {
    next()
  } else {
    next('/login')
  }
}

const routes = [
  {
    path: '/',
    component: DashboardLayout,
    redirect: '/dashboard',
    group: Users,
    beforeEnter: ifAuthenticated,
    children: [
      {
        path: '',
        name: 'SpacedContent',
        component: SpacedContent,
        redirect: '/dashboard',
        beforeEnter: ifAuthenticated,
        children: [
          {
            path: 'dashboard',
            name: 'General information',
            component: Dashboard,
            beforeEnter: ifAuthenticated
          },
          {
            path: 'support',
            name: 'Support',
            component: Support,
            beforeEnter: ifAuthenticated
          },
          {
            path: 'home',
            name: 'Home',
            component: Users,
            beforeEnter: ifAuthenticated
          },
          {
            path: 'accounts',
            name: 'Accounts',
            component: Accounts,
            beforeEnter: ifAuthenticated
          },
          {
            path: 'accountsGroups',
            name: 'Accounts groups',
            component: AccountsGroups,
            beforeEnter: ifAuthenticated
          },
          {
            path: 'systemusers',
            name: 'System users',
            component: SystemUsers,
            beforeEnter: ifAuthenticated
          },
          {
            path: 'groups',
            name: 'Groups',
            component: Groups,
            beforeEnter: ifAuthenticated
          },
          {
            path: 'systemGroups',
            name: 'System groups',
            component: SystemGroups,
            beforeEnter: ifAuthenticated
          },
          {
            path: 'cardpools',
            name: 'Card pools',
            component: CardPools,
            beforeEnter: ifAuthenticated
          },
          {
            path: 'banks',
            name: 'Banks',
            component: Banks,
            beforeEnter: ifAuthenticated
          },
          {
            path: 'buildings',
            name: 'Buildings',
            component: Buildings,
            beforeEnter: ifAuthenticated
          },
          {
            path: 'currency',
            name: 'Currency',
            component: Currency,
            beforeEnter: ifAuthenticated
          },
          {
            path: 'ipZone',
            name: 'IP zones',
            component: IPzone,
            beforeEnter: ifAuthenticated
          },
          {
            path: 'streets',
            name: 'Streets',
            component: Streets,
            beforeEnter: ifAuthenticated
          },
          {
            path: 'paymentsMethods',
            name: 'Payments methods',
            component: PaymentsMethods,
            beforeEnter: ifAuthenticated
          },
          {
            path: 'companies',
            name: 'Companies',
            component: Companies,
            beforeEnter: ifAuthenticated
          },
          {
            path: 'inventoryProfiles',
            name: 'Profiles',
            component: InventoryProfiles,
            beforeEnter: ifAuthenticated
          },
          {
            path: 'inventorySwitches',
            name: 'Switches',
            component: InventorySwitches,
            beforeEnter: ifAuthenticated
          },
          {
            path: 'users',
            name: 'Customers',
            component: Users,
            beforeEnter: ifAuthenticated
          },
          {
            path: 'deletedusers',
            name: 'Archived users',
            component: DeletedUsers,
            beforeEnter: ifAuthenticated
          },
          {
            path: 'tarrification',
            name: 'tarrification',
            component: SecondLevelLayout,
            beforeEnter: ifAuthenticated,
            children: [
              {
                path: 'Tariffs',
                name: 'Tariffs',
                component: TarifficationTariffs,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'Services',
                name: 'Services',
                component: TarifficationServices,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'ServicesTemplates',
                name: 'Services templates',
                component: TarifficationServicesTemplates,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'ServicesInTariffs',
                name: 'Services in tariffs',
                component: TarifficationServicesInTariffs,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'AccountingPeriods',
                name: 'Accounting periods',
                component: TarifficationAccountingPeriods,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'ChargePolicies',
                name: 'Charge policies',
                component: TarifficationChargePolicies,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'CoefficientScheme',
                name: 'Coefficient scheme',
                component: TarifficationCoefficientScheme,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'ContractType',
                name: 'Contract type',
                component: TarifficationContractType,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'TimeRanges',
                name: 'Time ranges',
                component: TarifficationTimeRanges,
                beforeEnter: ifAuthenticated
              }
            ]
          },
          {
            path: 'ReportsPayments',
            name: 'Payment reports',
            component: ReportsPayments,
            beforeEnter: ifAuthenticated,
            children: [
              {
                path: 'ReportsPaymentsPayments',
                name: 'Report payments',
                component: ReportsPaymentsPayments,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'ReportsPaymentOrders',
                name: 'Report payment orders',
                component: ReportsPaymentOrders,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'ReportsPaymentsInternalTransfer',
                name: 'Report internal transfer',
                component: ReportsPaymentsInternalTransfer,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'ReportsPaymentsExpiringPayments',
                name: 'Report expiring payments',
                component: ReportsPaymentsExpiringPayments,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'ReportsPaymentsOtherCharges',
                name: 'Report other charges',
                component: ReportsPaymentsOtherCharges,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'ReportsPaymentsDocuments',
                name: 'Report documents',
                component: ReportsPaymentsDocuments,
                beforeEnter: ifAuthenticated
              }
            ]
          },
          {
            path: 'ReportsServices',
            name: 'Service reports',
            component: ReportsServices,
            beforeEnter: ifAuthenticated,
            children: [
              {
                path: 'ReportsServicesGeneral',
                name: 'Report general',
                component: ReportsServicesGeneral,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'ReportsServicesServices',
                name: 'Report services',
                component: ReportsServicesServices,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'ReportsServicesCustomChargesReport',
                name: 'Report custom charges',
                component: ReportsServicesCustomChargesReport,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'ReportsServicesTraffic',
                name: 'Report traffic',
                component: ReportsServicesTraffic,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'ReportsServicesDetailedTraffic',
                name: 'Report detailed traffic',
                component: ReportsServicesDetailedTraffic,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'ReportsServicesTelephony',
                name: 'Report telephony',
                component: ReportsServicesTelephony,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'ReportsServicesTelephonyDirectionsReport',
                name: 'Reports telephony directions',
                component: ReportsServicesTelephonyDirectionsReport,
                beforeEnter: ifAuthenticated
              }
            ]
          },
          {
            path: 'ReportsOther',
            name: 'Reports other',
            component: ReportsOther,
            beforeEnter: ifAuthenticated,
            children: [
              {
                path: 'ReportsOtherBlocking',
                name: 'Report blocking',
                component: ReportsOtherBlocking,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'ReportsOtherChangeLog',
                name: 'Report changeLog',
                component: ReportsOtherChangeLog,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'ReportsOtherDHCPLease',
                name: 'Report DHCP Lease',
                component: ReportsOtherDHCPLease,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'ReportsOtherSessions',
                name: 'Report other sessions',
                component: ReportsOtherSessions,
                beforeEnter: ifAuthenticated
              }
            ]
          },
          {
            path: 'inventory',
            name: 'Inventory',
            component: SecondLevelLayout,
            beforeEnter: ifAuthenticated,
            children: [
              {
                path: 'netFlowproviders',
                name: 'NetFlow providers',
                component: NetFlowproviders,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'trafficCollectors',
                name: 'Traffic collectors',
                component: TrafficCollectors,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'firewalls',
                name: 'Firewalls',
                component: Firewalls,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'firewallRules',
                name: 'Firewall rules',
                component: FirewallRules,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'NASlist',
                name: 'NAS list',
                component: NASlist,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'RabbitMQ',
                name: 'RabbitMQ',
                component: RabbitMQ,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'HTTPServers',
                name: 'HTTP Servers',
                component: HTTPServers,
                beforeEnter: ifAuthenticated
              }
            ]
          },
          {
            path: 'system',
            name: 'System',
            component: SecondLevelLayout,
            beforeEnter: ifAuthenticated,
            children: [
              {
                path: 'SettingsSystem',
                name: 'System settings',
                component: SettingsSystem,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'additional',
                name: 'Additional',
                component: Additional,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'archiveDB',
                name: 'Archive DB',
                component: ArchiveDB,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'radiusAccounts',
                name: 'RADIUS accounts',
                component: radiusAccounts,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'dynamicShaping',
                name: 'Dynamic shaping',
                component: DynamicShaping,
                beforeEnter: ifAuthenticated
              }
            ]
          },
          {
            path: 'network',
            name: 'network',
            component: SecondLevelLayout,
            beforeEnter: ifAuthenticated,
            children: [
              {
                path: 'ISGattributes',
                name: 'ISG attributes',
                component: NetworkISGattributes,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'TunnelRadiusAttribute',
                name: 'Tunnel Radius Attributes',
                component: NetworkTunnelRadiusAttributes,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'ISGprofile',
                name: 'ISG profile',
                component: NetworkISGprofile,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'TrafficClasses',
                name: 'Traffic classes',
                component: NetworkTrafficClasses,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'ipPools',
                name: 'IP pools',
                component: NetworkIPpools,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'ipgroups',
                name: 'IP groups',
                component: NetworkIPGroups,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'DhcpPools',
                name: 'DHCPv4 pools',
                component: NetworkDhcpPools,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'DhcpLeases',
                name: 'DHCPv4 leases',
                component: NetworkDhcpLeases,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'DHCPv6',
                name: 'DHCPv6',
                component: NetworkDHCPv6Tab,
                beforeEnter: ifAuthenticated,
                children: [
                  {
                    path: 'mainDHCPv6',
                    name: 'mainDHCPv6',
                    component: mainDHCPv6,
                    beforeEnter: ifAuthenticated
                  },
                  {
                    path: 'subnets',
                    name: 'SubnetsTab',
                    component: Subnets,
                    beforeEnter: ifAuthenticated
                  },
                  {
                    path: 'sharedNetworks',
                    name: 'SharedNetworks',
                    component: SharedNetworks,
                    beforeEnter: ifAuthenticated
                  },
                  {
                    path: 'clientClassification',
                    name: 'ClientClassification',
                    component: ClientClassification,
                    beforeEnter: ifAuthenticated
                  },
                  {
                    path: 'optionDef',
                    name: 'OptionDef',
                    component: OptionDef,
                    beforeEnter: ifAuthenticated
                  }
                ]
              }
            ]
          },
          {
            path: 'telephony',
            name: 'Telephony',
            component: SecondLevelLayout,
            beforeEnter: ifAuthenticated,
            children: [
              {
                path: 'emergencyCalls',
                name: 'Emergency calls',
                component: EmergencyCalls,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'telephoneOperators',
                name: 'Telephone operators',
                component: TelephoneOperators,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'TelephoneTarifficationZones',
                name: 'Zones',
                component: TelephoneTarifficationZones,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'TelephoneTarifficationDirections',
                name: 'Directions',
                component: TelephoneTarifficationDirections,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'telephonenum',
                name: 'Telephony numbers',
                component: TelephoneNum,
                beforeEnter: ifAuthenticated
              }
            ]
          },
          {
            path: 'documents',
            name: 'Documents',
            component: SecondLevelLayout,
            beforeEnter: ifAuthenticated,
            children: [
              {
                path: 'documentTemplates',
                name: 'Document templates',
                component: DocumentTemplates,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'profilesOfDocuments',
                name: 'Profiles of documents',
                component: ProfilesOfDocuments,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'replacementsInDocument',
                name: 'Replacements in document',
                component: ReplacementsInDocument,
                beforeEnter: ifAuthenticated
              }
            ]
          },
          {
            path: 'CustomerPortal',
            name: 'CustomerPortal',
            component: SecondLevelLayout,
            beforeEnter: ifAuthenticated,
            children: [
              {
                path: 'SettingsPaymentSystems',
                name: 'Payment systems',
                component: CustomerPaymentSystems,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'SettingsTransferFunds',
                name: 'Internal transfer',
                component: CustomerTransferFunds,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'SettingsSwitchTariff',
                name: 'Switch tariff',
                component: CustomerSwitchTariff,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'SettingsPromisedPayments',
                name: 'Promised payments',
                component: CustomerPromisedPayments,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'SettingsVoluntarySuspension',
                name: 'Voluntary suspension',
                component: CustomerVoluntarySuspension,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'SettingsCustomerIndependentServiceConnect',
                name: 'Independent service connect',
                component: CustomerIndependentServiceConnect,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'SettingsCaptivePortal',
                name: 'CaptivePortal',
                component: CustomerCaptivePortal,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'SettingsCustomerRentsoft',
                name: 'Rentsoft',
                component: CustomerCustomerRentsoft,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'SettingsCustomerTSChat',
                name: 'Tech support chat',
                component: CustomerCustomerTSChat,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'SettingsActivatingCard',
                name: 'Activating card',
                component: CustomerActivatingCard,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'SettingsEditProfile',
                name: 'Edit profile',
                component: CustomerEditProfile,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'SettingsAvailReports',
                name: 'Customer reports',
                component: CustomerAvailReports,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'SettingsAvailDocs',
                name: 'Customer docs',
                component: CustomerAvailDocs,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'SettingsAvailContracts',
                name: 'Customer contracts',
                component: CustomerAvailContracts,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'Settings24TV',
                name: 'Customer 24TV',
                component: Customer24TV,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'SettingsSSRService',
                name: 'Socially significant resources',
                component: CustomerSSRService,
                beforeEnter: ifAuthenticated
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/logout',
    name: 'Logout',
    component: Logout,
    beforeEnter: ifAuthenticated
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/routes/routes.js